/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LatestBeforePartitionValue { 
    /**
     * The partition value that is an inclusive upper bound for the latest available partition value. Required when                   latestBeforePartitionValue is present                
     */
    partitionValue: string;
}
